import { render } from "./HeroiconsOutlineCurrencyRupee.vue?vue&type=template&id=f05d41a0"
const script = {}

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCurrencyRupee.vue"]])

export default __exports__